// extracted by mini-css-extract-plugin
export default {"checkout_summary":"eu","checkout_summary_wrapper":"fu","summary_items":"gu","line_items_wrapper":"hu","separator":"iu","order_summary":"ju","line_item":"ku","order__summary_item_title":"lu","recurringdis":"mu","note":"nu","carbon_emission":"ou","unlock_savings":"pu","member_perk":"qu","info":"ru","no_items":"su","promo":"tu","order_summary_mobile":"uu","open_summary_mobile":"vu","fixed_bottom_info":"wu","open_info":"xu","text":"yu","open_summary":"zu"};
    if(module.hot) {
      // 1738064238246
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  